<template>
  <div class="flex-1 p-4 grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-6 self-start" style="min-width: 500px;">

    <!-- 清掃員の場合 -->
    <div class="font-bold text-xl text-gray-600 mb-3 col-span-full">
      清掃員
      <span class="pl-5 text-red-700 text-sm">「採用」の場合、タスク完了時に雇い入れタスクが自動登録されます</span>
    </div>

    <div class="sm:col-span-full">
      <SelectionButton2
        name="acceptanceSelections"
        v-model="requestPost.interviewsResult"
        :item ="acceptanceSelections"
        :multiSelect="false"
        :disabled="referenceMode||requestPost.interviewsResNotEditable"
        @change="setTitle('採否')"
      />
      <div v-if="requestPost.resultSetDate" class="mt-1 text-xs font-bold text-purple-500 w-fit ml-auto">採否決定日： {{ requestPost.resultSetDate }}</div>
    </div>

    <!-- 清掃員 面接 -->
    <div class="col-span-full">
      <div class="sm:col-span-full">
        <WmsDateInput
          name="interviewsHireDate"
          caption="入社日"
          v-model="requestPost.interviewsHireDate"
          :clearable="true"
          :required="isAdopt"
          :error="!requireValidateStr('interviewsHireDate', '入社日').result"
          :errorMessage="requireValidateStr('interviewsHireDate', '入社日').message"
          @change="requestPost.startDateWork=requestPost.interviewsHireDate"
          :disabled="referenceMode"
        />
      </div>

      <InputGroupLabel
        name="categoryTitle"
        caption=""
        class="mt-5"
      />

      <div class="sm:col-span-full mt-3">
        <WmsDateInput
          name="interviewsInputDay"
          caption="入力日"
          v-model="requestPost.interviewsInputDay"
          :clearable="true"
          :disabled="referenceMode"
        />
      </div>

      <div class="sm:col-span-full mt-3">
        <WmsTextInput
          name="interviewsKana"
          caption="フリガナ"
          v-model="requestPost.interviewsKana"
          :disabled="referenceMode"
          :required="true"
          :error="!requireValidateStr('interviewsKana', 'フリガナ').result"
          :errorMessage="requireValidateStr('interviewsKana', 'フリガナ').message"
        />
      </div>

      <div class="sm:col-span-full mt-3">
        <WmsTextInput
          name="interviewsName"
          caption="氏名"
          v-model="requestPost.interviewsName"
          :disabled="referenceMode"
          @change="setTitle()"
          :required="true"
          :error="!requireValidateStr('interviewsName', '氏名').result"
          :errorMessage="requireValidateStr('interviewsName', '氏名').message"
        />
      </div>

      <div class="sm:col-span-full mt-3">
        <label for="interviewsPostCode" class="block text-xs font-bold text-gray-700 relative">
          郵便番号
          <span class="absolute -top-0.5 ml-1 text-red-500"> * </span>
          <span class="text-xs font-bold text-red-500 ml-5">{{ errPostCode(requestPost.interviewsPostCode) }}</span>
        </label>
        <div class=" flex gap-2">
          <div class="mt-1 flex relative">
            <InputIcon v-if="!requireValidateStr('interviewsPostCode', '郵便番号').result" iconName="ExclamationCircle" iconColor="red" :message="requireValidateStr('interviewsPostCode', '郵便番号').message" />
            <input
              type="tel"
              name="interviewsPostCode"
              v-model="requestPost.interviewsPostCode"
              :disabled="referenceMode"
              class="py-1.5 focus:ring-indigo-500 focus:border-indigo-500 block sm:text-sm border-gray-300 rounded"
              :class="referenceMode?'bg-gray-200 cursor-not-allowed text-gray-500':''"
              @keypress="onKeyPressTel"
            />
          </div>
          <div class="" v-if="!referenceMode">
            <PrimaryButton text="住所検索" class="w-40 bg-green-500 mr-2" @click="addressSearch(requestPost.interviewsPostCode, 'interviewsAddress1')">
            </PrimaryButton>

            <PrimaryButton text="住所から取得" class="w-40 bg-green-500" @click="postalCodeSearch(requestPost.interviewsAddress1+requestPost.interviewsAddress2, 'interviewsPostCode')">
            </PrimaryButton>
          </div>
        </div>
      </div>

      <div class="sm:col-span-full mt-3">
        <WmsTextInput
          name="interviewsAddress1"
          caption="住所１"
          v-model="requestPost.interviewsAddress1"
          :disabled="referenceMode"
          :required="true"
          :error="!requireValidateStr('interviewsAddress1', '住所１').result"
          :errorMessage="requireValidateStr('interviewsAddress1', '住所１').message"
        />
      </div>

      <div class="sm:col-span-full mt-3">
        <WmsTextInput
          name="interviewsAddress2"
          caption="住所２"
          v-model="requestPost.interviewsAddress2"
          :disabled="referenceMode"
        />
      </div>

      <div class="sm:col-span-full mt-3">
        <label for="interviewsTel" class="block text-xs font-bold text-gray-700">固定電話</label>
        <div class="mt-1 flex relative">
          <input
            type="tel"
            name="interviewsTel"
            v-model="requestPost.interviewsTel"
            :disabled="referenceMode"
            class="py-1.5 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded"
            :class="referenceMode?'bg-gray-200 cursor-not-allowed text-gray-500':''"
            @keypress="onKeyPressTel"
            autocomplete="off"
          />
        </div>
      </div>

      <div class="sm:col-span-full mt-3">
        <label for="interviewsMobile" class="block text-xs font-bold text-gray-700 relative">
          携帯電話
          <span class="absolute -top-0.5 ml-1 text-red-500"> * </span>
          <span v-if="errMobile(requestPost.interviewsMobile)" class="text-xs font-bold text-red-500 ml-5">{{ errMobile(requestPost.interviewsMobile) }}</span>
        </label>
        <div class="mt-1 flex relative">
          <InputIcon v-if="!requireValidateStr('interviewsMobile', '携帯電話').result" iconName="ExclamationCircle" iconColor="red" :message="requireValidateStr('interviewsMobile', '携帯電話').message" />
          <input
            type="tel"
            name="interviewsMobile"
            v-model="requestPost.interviewsMobile"
            :disabled="referenceMode"
            class="py-1.5 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded"
            :class="referenceMode?'bg-gray-200 cursor-not-allowed text-gray-500':''"
            @keypress="onKeyPressTel"
            autocomplete="off"
          />
        </div>
      </div>

      <div class="sm:col-span-full mt-3">
        <SelectionButton2
          name="interviewsSex"
          caption="性別"
          v-model="requestPost.interviewsSex"
          :item ="sexSelections"
          :multiSelect="false"
          :disabled="referenceMode"
          :required="isAdopt"
          :error="!requireValidateArr('interviewsSex', '性別').result"
          :errorMessage="requireValidateArr('interviewsSex', '性別').message"
        />
      </div>

      <div class="sm:col-span-full mt-3">
        <WmsDateInput
          name="interviewsBirthDay"
          caption="生年月日"
          v-model="requestPost.interviewsBirthDay"
          @change="ageCalculation"
          :clearable="true"
          :required="true"
          :disabled="referenceMode"
          :error="!requireValidateStr('interviewsBirthDay', '生年月日').result"
          :errorMessage="requireValidateStr('interviewsBirthDay', '生年月日').message"
        />
      </div>

      <div class="sm:col-span-full text-blue-800 mt-3">
        <div v-if="requestPost.interviewsBirthDay" class="mt-auto mb-2 mx-3 text-sm">
          和暦： {{ japaneseDate(requestPost.interviewsBirthDay) }}
        </div>
      </div>

      <!-- 年齢は削除しちゃダメ。集計で取得している -->
      <div class="sm:col-span-full mt-3">
        <NumericTextInput2
          name="interviewsAge"
          caption="年齢"
          maxLenght="3"
          v-model="requestPost.interviewsAge"
          :disabled="true"
          :required="true"
          :error="!requireValidateStr('interviewsAge', '年齢').result"
          :errorMessage="requireValidateStr('interviewsAge', '年齢').message"
        />
      </div>

      <div class="sm:col-span-full mt-3">
        <WmsTextInput
          name="interviewsNearestStationFromHome"
          caption="御自宅からの最寄駅"
          v-model="requestPost.interviewsNearestStationFromHome"
          :disabled="referenceMode"
        />
      </div>

      <div class="sm:col-span-full mt-7">
        <label for="interviewsMedium" class="block text-xs font-bold text-gray-700 relative">
          募集媒体
          <span class="text-blue-700 cursor-pointer px-3 ml-5 py-1 text-xs underline" @click="openMediaModal=true">ドロップダウンに該当するものがない時はこちらをクリック</span>
        </label>
        <div class="mt-1 flex relative">
          <select
            name="interviewsMedium"
            v-model="requestPost.interviewsMedium"
            class="focus:ring-indigo-500 focus:border-indigo-500 block border-gray-300 w-full text-sm rounded"
            :class="referenceMode?'bg-gray-200 cursor-not-allowed':'bg-white'"
            :disabled="referenceMode"
          >
            <option
              v-for="list in mediaList" :key='list._id'
              :value="list.name"
              class="bg-white">
              {{ list.name }}
            </option>
          </select>
        </div>
      </div>

      <!-- *******************シルバー交通費******************* -->
      <!-- <div class="sm:col-span-full mt-10">
        <InputGroupLabel
          caption="シルバー交通費"
        />
      </div>

      <div class="sm:col-span-full grid grid-cols-10 mt-2">
        <div class="sm:col-span-3">
          <select
            v-model="requestPost.silverMonth"
            :disabled="referenceMode"
            class="focus:ring-indigo-500 focus:border-indigo-500 block border-gray-300 w-full text-sm rounded"
            :class="referenceMode?'cursor-not-allowed bg-gray-200':''"
          >
            <option
              v-for="c in [null, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]" :key="'silver'+c"
              :value="c"
              class="bg-white">
              {{ c }}
            </option>
          </select>
        </div>

        <div class="sm:col-span-1 ml-1 mt-auto text-sm">
          月 に
        </div>

        <div class="sm:col-span-5">
          <NumericTextInput2
            name="silverPrice"
            v-model="requestPost.silverPrice"
            :disabled="referenceMode"
          />
        </div>

        <div class="sm:col-span-1 ml-1 text-sm mt-auto">
          円
        </div>
      </div> -->

      <!-- *******************リーダー手当（月額）******************* -->
      <!-- <div class="sm:col-span-full mt-10">
        <InputGroupLabel
          caption="リーダー手当（月額）"
        />
      </div>

      <div class="sm:col-span-full">
        <NumericTextInput2
          name="leaderAllowance"
          v-model="requestPost.leaderAllowance"
          :disabled="referenceMode"
        />
      </div> -->

      <!-- *******************ご家族について******************* -->
      <div class="sm:col-span-full grid grid-cols-10 mt-10">
        <div class="sm:col-span-9">
          <InputGroupLabel
            name="familyTitle"
            caption="ご家族について"
          />
        </div>

        <!-- 家族追加ボタン -->
        <div class="addButton-contents sm:col-span-1" v-if="!referenceMode">
          <PrimaryButton class="bg-green-500" size="other" :buttonContents="'要'" v-tooltip="'追加'" @click="addFamilyMember">
            <Icon slot="before" iconName="PlusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
          </PrimaryButton>
        </div>
      </div>

      <div v-for="(FamilyMember, index) in requestPost.familyMembers" :key="'f'+index"  class="sm:col-span-full grid grid-cols-10">

        <div class="sm:col-span-1 pr-1">
          <WmsSuggestInput
            name="relationship"
            caption="関係"
            :selectionItems="familyRelations"
            displayField="text"
            v-model="FamilyMember.relationship"
            :disabled="referenceMode"
            />
        </div>

        <div class="sm:col-span-2 pr-1">
          <WmsTextInput
            name="interviewsFamilyName"
            caption="氏名"
            v-model="FamilyMember.name"
            :disabled="referenceMode"
          />
        </div>

        <div class="sm:col-span-4 pr-1">
          <WmsTextInput
            name="interviewsFamilyAddress"
            caption="住所"
            v-model="FamilyMember.address"
            :disabled="referenceMode"
          />
        </div>

        <div class="sm:col-span-2 pr-1">
          <label for="interviewsFamilyPhoneNumber" class="block text-xs font-bold text-gray-700">電話番号</label>
          <div class="mt-1 flex relative">
            <input
              type="tel"
              name="interviewsFamilyPhoneNumber"
              v-model="FamilyMember.phoneNumber"
              :disabled="referenceMode"
              class="py-1.5 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded"
              :class="referenceMode?'bg-gray-200 cursor-not-allowed text-gray-500':''"
              @keypress="onKeyPressTel"
              autocomplete="off"
            />
          </div>
        </div>

        <!-- 家族削除ボタン -->
        <div class="sm:col-span-1 deleteButton-contents mt-5" v-if="!referenceMode">
          <PrimaryButton class="bg-red-500" size="other" :buttonContents="'要'" v-tooltip="'削除'" @click="removeFamilyMember(index)">
            <Icon slot="before" iconName="MinusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
          </PrimaryButton>
        </div>

      </div>

      <!-- *******************緊急連絡先******************* -->
      <div class="sm:col-span-full grid grid-cols-10 mt-16">
        <div class="sm:col-span-9">
          <InputGroupLabel
            name="categoryTitle"
            caption="緊急連絡先"
          />
        </div>

        <!-- 緊急追加ボタン -->
        <div class="addButton-contents sm:col-span-1" v-if="!referenceMode">
          <PrimaryButton class="bg-green-500" size="other" :buttonContents="'要'" v-tooltip="'追加'" @click="addEmergency()">
            <Icon slot="before" iconName="PlusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
          </PrimaryButton>
        </div>
      </div>

      <div v-for="(row, i) in requestPost.emergency" :key="'ema'+i"  class="sm:col-span-full">
        <div class="sm:col-span-full grid grid-cols-10">
          <div class="sm:col-span-2 pr-1">
            <WmsSuggestInput
              :name="'er'+i"
              caption="関係"
              :selectionItems="familyRelations"
              displayField="text"
              v-model="row.relationship"
              :disabled="referenceMode"
            />
          </div>

          <div class="sm:col-span-4 pr-1">
            <WmsTextInput
              :name="'en'+i"
              :id="'en'+i"
              caption="氏名"
              v-model="row.name"
              :disabled="referenceMode"
            />
          </div>

          <div class="sm:col-span-4 pr-1">
            <WmsTextInput
              :name="'ek'+i"
              caption="フリガナ"
              v-model="row.kana"
              :disabled="referenceMode"
            />
          </div>
        </div>

        <div class="flex gap-2 mt-3">
          <div class="w-1/5">
            <label class="block text-xs font-bold text-gray-700">
              郵便番号
            </label>
            <div class="mt-1 flex relative">
              <input
                type="tel"
                v-model="row.postCode"
                :disabled="referenceMode"
                class="py-1.5 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded"
                :class="referenceMode?'bg-gray-200 cursor-not-allowed text-gray-500':''"
                @keypress="onKeyPressTel"
              />
            </div>
          </div>
          <div class="flex self-end gap-2" v-if="!referenceMode">
            <PrimaryButton text="住所検索" size="xs" class=" bg-green-500" @click="addressSearch(row.postCode, 'address', i)">
            </PrimaryButton>

            <PrimaryButton text="住所から取得" size="xs" class=" bg-green-500" @click="postalCodeSearch(row.address, 'postCode', i)">
            </PrimaryButton>
          </div>

          <div class="flex-1">
            <WmsTextInput
              :name="'ea'+i"
              caption="住所"
              v-model="row.address"
              :disabled="referenceMode"
            />
          </div>
        </div>
        <div class="text-xs font-bold text-red-500">{{ errPostCode(row.postCode) }}</div>

        <div class="flex gap-2 mt-3">
          <div class="flex-1">
            <label for="emergencyPhoneNumber" class="block text-xs font-bold text-gray-700">電話番号</label>
            <div class="mt-1 flex relative">
              <input
                type="tel"
                v-model="row.phoneNumber"
                :disabled="referenceMode"
                class="py-1.5 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded"
                :class="referenceMode?'bg-gray-200 cursor-not-allowed text-gray-500':''"
                @keypress="onKeyPressTel"
                autocomplete="off"
              />
            </div>
          </div>
        </div>

        <!-- 緊急削除ボタン -->
        <div class="w-fit deleteButton-contents mt-5 ml-auto" v-if="!referenceMode">
          <PrimaryButton class="bg-red-500" size="other" :buttonContents="'要'" v-tooltip="'削除'" @click="removeEmergency(i)">
            <Icon slot="before" iconName="MinusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
          </PrimaryButton>
        </div>
      </div>

      <!-- スマイル移行で追加項目 -->
      <!-- *******************清掃員に関するメモ******************* -->
      <!-- <div class="sm:col-span-full mt-3">
        <WmsTextInput
          name="noteStaff"
          caption="清掃員に関するメモ（清掃員マスタに保存します）"
          v-model="requestPost.noteStaff"
          :multiline="true"
          :rows="3"
          :disabled="referenceMode"
        />
      </div> -->


      <!-- *******************雇用指示******************* -->
      <InputGroupLabel
        name="siteData"
        caption="雇用指示"
        class="mt-10"
      />

      <div class="sm:col-span-full">
        <WmsDateInput
          name="startDateWork"
          caption="作業開始日"
          v-model="requestPost.startDateWork"
          :min="requestPost.interviewsHireDate"
          class="mt-3"
          :disabled="referenceMode"
          :required="isAdopt"
          :error="!requireValidateStr('startDateWork', '作業開始日').result"
          :errorMessage="requireValidateStr('startDateWork', '作業開始日').message"
        />
      </div>

      <div class="sm:col-span-full mt-3">
        <div class="text-xs font-bold text-gray-700">ご応募いただいた勤務物件 <span>※代勤専門の場合も要選択 </span><span class="ml-1 text-red-500"> * </span></div>
        <WmsSuggestInput
          name="interviewsAppliedWorkLocationAddress"
          :selectionItems="buildingList"
          displayField="nameSite"
          v-model="requestPost.interviewsAppliedWorkLocationAddress"
          :disabled="referenceMode"
          :required="isAdopt"
          :error="!requireValidateStr('interviewsAppliedWorkLocationAddress', 'ご応募いただいた勤務物件').result"
          :errorMessage="requireValidateStr('interviewsAppliedWorkLocationAddress', 'ご応募いただいた勤務物件').message"
          @selected="siteSelected($event)"
          @change="siteChanged()"
          @blur="setTitle()"
        >
          <!-- 検索アイコン -->
          <template #addon-content>
            <Icon
              iconName="Search"
              :clickable="true"
              class="w-4 h-4 mr-0.5"
              @click="openSiteModal()"
            />
          </template>
        </WmsSuggestInput>
      </div>

      <div v-if="requestPost.interviewsAppliedWorkLocationAddress" class="sm:col-span-full mt-3 text-sm font-bold text-blue-700 ml-3">
        <div v-if="requestPost.interviewsSiteCode!='000000000'" class="mb-2">
          <PrimaryButton :text="requestPost.targetSite + ' の情報を再取得'" @click="getDetilSiteInfo(false)">
            <LoadingIcon v-if="loading" slot="before" class="h-4 w-4" />
          </PrimaryButton>
        </div>
        <div>●物件コード： {{ requestPost.interviewsSiteCode }}</div>

        <!-- スマイル移行後に復活 -->
        <!-- <div v-if="requestPost.interviewsSiteCode=='000000000'" class="my-1">●代勤専門の場合、契約コードは「 {{ requestPost.contractCode }} 」で登録されます。</div> -->
        <div v-if="requestPost.interviewsSiteCode!='000000000'" class="my-1">●物件住所： {{ requestPost.interviewsSiteAddress }}</div>
      </div>

      <div class="mt-3">
        <div v-if="!loading&&requestPost.siteShort&&Object.keys(requestPost.siteShort).length" class="bg-blue-50 border border-blue-700 p-2 rounded w-fit mb-5 mr-3">
          <div class="text-xs font-bold text-gray-700 mt-1">物件単位の時間差</div>
          <div class="text-xs font-bold text-gray-700">※マイナスは契約時間を満たしていないことを表します。</div>
          <div class="text-xs font-bold text-gray-700">※1週間分を計算しているため勤務形態が毎週以外はご注意ください。</div>
          <div class="text-xs font-bold text-yellow-700 mt-2" v-if="requestPost.siteShort.total == '0'">過不足なし</div>

          <div class="flex mt-3 mb-1 text-gray-700">
            <div class="mx-2 font-bold" :class="requestPost.siteShort.totalColor">
              <p>TOTAL</p>
              <p class="text-center">{{ requestPost.siteShort.total }}</p>
            </div>
            <div class="mx-2" :class="requestPost.siteShort.monColor">
              <p class="text-center">月</p>
              <p class="text-center">{{ requestPost.siteShort.mon }}</p>
            </div>
            <div class="mx-2" :class="requestPost.siteShort.tueColor">
              <p class="text-center">火</p>
              <p class="text-center">{{ requestPost.siteShort.tue }}</p>
            </div>
            <div class="mx-2" :class="requestPost.siteShort.wedColor">
              <p class="text-center">水</p>
              <p class="text-center">{{ requestPost.siteShort.wed }}</p>
            </div>
            <div class="mx-2" :class="requestPost.siteShort.thuColor">
              <p class="text-center">木</p>
              <p class="text-center">{{ requestPost.siteShort.thu }}</p>
            </div>
            <div class="mx-2" :class="requestPost.siteShort.friColor">
              <p class="text-center">金</p>
              <p class="text-center">{{ requestPost.siteShort.fri }}</p>
            </div>
            <div class="mx-2" :class="requestPost.siteShort.satColor">
              <p class="text-center">土</p>
              <p class="text-center">{{ requestPost.siteShort.sat }}</p>
            </div>
            <div class="mx-2" :class="requestPost.siteShort.sunColor">
              <p class="text-center">日</p>
              <p class="text-center">{{ requestPost.siteShort.sun }}</p>
            </div>
          </div>
          <div class="text-right text-xs mt-1 text-gray-700">{{ requestPost.siteShort.date }} 時点</div>
        </div>

          <div v-if="requestPost.contract&&requestPost.contract.length" class="text-sm flex gap-2 flex-wrap mt-3">
            <div v-for="(row, i) in requestPost.contract" :key="'cont'+i" class="border border-blue-700 rounded p-2">
              <p class="font-bold mb-1">契約コード（{{ row.cdContract }}）<span v-if="!row.type" class="text-xs pl-3 text-red-700">※清掃員がいない欠員物件です</span></p>
              <div class="flex">
                <div class="p-2 bg-green-50 text-gray-700 whitespace-nowrap">
                  <p class="font-bold text-xs mb-3">契約時間</p>
                  <p>{{ row.mon || '月：×' }}</p>
                  <p>{{ row.tue || '火：×' }}</p>
                  <p>{{ row.wed || '水：×' }}</p>
                  <p>{{ row.thu || '木：×' }}</p>
                  <p>{{ row.fri || '金：×' }}</p>
                  <p>{{ row.sat || '土：×' }}</p>
                  <p>{{ row.sun || '日：×' }}</p>
                </div>
                <div class="ml-3 p-2 bg-yellow-50 text-gray-700 whitespace-nowrap">
                  <p class="font-bold text-xs mb-3">１週間の差</p>
                  <p :class="row.mon2Color">{{ '月： ' + Number(row.mon2) }}</p>
                  <p :class="row.tue2Color">{{ '火： ' + Number(row.tue2) }}</p>
                  <p :class="row.wed2Color">{{ '水： ' + Number(row.wed2) }}</p>
                  <p :class="row.thu2Color">{{ '木： ' + Number(row.thu2) }}</p>
                  <p :class="row.fri2Color">{{ '金： ' + Number(row.fri2) }}</p>
                  <p :class="row.sat2Color">{{ '土： ' + Number(row.sat2) }}</p>
                  <p :class="row.sun2Color">{{ '日： ' + Number(row.sun2) }}</p>
                </div>
                <div class="ml-2 text-xs text-blue-700">
                  <div class="mb-2">●作業内容：{{ getNameContentsWork(row.cdContentsWork) }}</div>
                  <div class="mb-2">●祝日勤務：{{ getNameHoliday(row.holiday) }}</div>
                  <div class="mb-2">●全社祝日勤務：{{ getNameYesNo(row.companyHoliday) }}</div>
                  <div>●ゴミ搬出 ：{{ getNameYesNo(row.garbage) }}</div>
                  <div class="text-right text-xs text-gray-700 mt-5 font-bold">{{ row.date }} 時点</div>
                </div>
              </div>
            </div>
          </div>
      </div>

      <div v-if="requestPost.contract&&requestPost.contract.length" class="sm:col-span-full my-3">
        <div class="text-xs text-gray-600 font-bold mb-1">
          契約コード<span v-if="isAdopt" class="ml-1 text-red-500"> * </span>
        </div>
        <div class="flex gap-1">
          <Icon v-if="isAdopt&&!requestPost.contractCode" iconName="ExclamationCircle" class="h-5 w-5 text-red-400 self-center" />
          <select
            class="w-full rounded border-gray-300 text-sm"
            v-model="requestPost.contractCode"
            :disabled="referenceMode"
            :class="referenceMode?'bg-gray-200 cursor-not-allowed text-gray-800':''"
            @change="changeContract()"
          >
            <option v-for="(row, i) in requestPost.contract" :value="row.cdContract" :key="'con'+i">
              {{ row.cdContract }}
            </option>
          </select>
        </div>
      </div>
      <!-- 代勤の場合 -->
      <div v-else-if="requestPost.interviewsSiteCode=='000000000'">
        <WmsTextInput
          name="contractCode"
          caption="契約コード"
          v-model="requestPost.contractCode"
          :disabled="true"
          class="mt-3"
        />
      </div>

      <div class="sm:col-span-full relative mt-3">
        <div class="text-xs text-gray-600 font-bold relative" style="margin-bottom:4px;">
          エリア <span v-if="requestPost.interviewsSiteCode=='000000000'">（代勤専門の場合は、清掃員の住所からエリアを判定）</span><span v-if="isAdopt" class="absolute -top-0.5 ml-1 text-red-500"> * </span>
        </div>
        <div class="relative">
          <InputIcon v-if="!requireValidateStr('area', 'エリア').result" iconName="ExclamationCircle" iconColor="red" :message="requireValidateStr('area', 'エリア').message" />
          <select
            class="w-full rounded border-gray-300 text-sm"
            v-model="requestPost.area"
            :disabled="referenceMode"
            :class="referenceMode?'bg-gray-200 cursor-not-allowed text-gray-800':''"
          >
            <option v-for="(row, index) in areaSelections" :value="row" :key="'a'+index">
              {{ row }}
            </option>
          </select>
        </div>
      </div>

      <!-- *******************勤務曜日・時間******************* -->
      <!-- 1週間の実働 -->
      <div class="text-green-700 font-bold mt-3 mb-2 flex justify-between">
        <div>1週間の実働：{{ totalHours }} 時間 <span v-if="!referenceMode" class="pl-5 text-xs text-red-700">※曜日をクリックでON・OFF可能</span></div>

        <!-- 追加ボタン -->
        <div v-if="!referenceMode" class="addButton-contents">
          <PrimaryButton class="bg-green-500" size="other" :buttonContents="'要'" v-tooltip="'追加'" @click="addAppliedWork()">
            <Icon slot="before" iconName="PlusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
          </PrimaryButton>
        </div>
      </div>

      <div v-for="(aw, i) in requestPost.appliedWork" v-bind:key="'AppliedWork' + i"  class="sm:col-span-full mb-3 p-2 rounded border-2 border-green-700">

        <div class="mt-1 text-right" v-if="!referenceMode&&i>0">
          <!-- 勤務曜日・時間 削除ボタン -->
          <PrimaryButton class="bg-red-500" size="other" :buttonContents="'要'" v-tooltip="'削除'" @click="removeAppliedWork(i)">
            <Icon slot="before" iconName="MinusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
          </PrimaryButton>
        </div>

        <!-- 勤務 -->
        <div class="flex mt-1 gap-1">
          <div v-for="(w, j) in weekList" :key="i+'w'+j"
            class="p-0.5 text-sm text-white font-bold rounded flex flex-col flex-1 text-center multi"
            :class="aw['attendance' + w.id]&&aw['attendance' + w.id].length?'bg-green-800':'bg-gray-300'"
          >
            <div @click="clickWeek(aw, 'attendance' + w.id)" class="cursor-pointer py-0.5 px-2 mb-1 rounded border border-green-800">{{ w.name }}</div>

            <!-- 形態 -->
            <multiselect
              v-if="!referenceMode"
              v-model="aw['attendance' + w.id]"
              :options="attendanceList"
              :multiple="true"
              :close-on-select="false"
              :show-labels="false"
              :searchable="false"
              :allow-empty="true"
              :hide-selected="true"
              label="name"
              track-by="id"
              class="multiselect text-sm"
              placeholder="勤務曜日なら要選択"
              @input="reloadAttendance++"
            ></multiselect>
            <!-- 編集不可の場合 -->
            <div v-else-if="aw['attendance' + w.id]&&aw['attendance' + w.id].length">
              <div v-for="(a, k) in aw['attendance' + w.id]" :key="i+'ww'+j+'a'+k" class="text-white text-sm font-bold bg-green-500 rounded w-20 mx-auto my-1">
                {{ a.name }}
              </div>
            </div>

            <div v-if="aw['attendance' + w.id]&&aw['attendance' + w.id].length" >
              <!-- 開始 -->
              <div class="mx-auto w-fit">
                <WmsTimeInput2
                  v-model="aw['start' + w.id]"
                  :clearable="true"
                  :hourItems="hourItems"
                  :minuteItems="minuteItems"
                  :disabled="referenceMode"
                  @blur="setTime(aw, w.id)"
                  @select="setTime(aw, w.id)"
                />
              </div>

              <!-- ～ -->
              <div class="font-bold text-white">～</div>

              <!-- 終了 -->
              <div class="mx-auto w-fit">
                <WmsTimeInput2
                  v-model="aw['end' + w.id]"
                  :clearable="true"
                  :hourItems="hourItems"
                  :minuteItems="minuteItems"
                  :disabled="referenceMode"
                  @blur="setTime(aw, w.id)"
                  @select="setTime(aw, w.id)"
                />
              </div>

              <!-- 実働時間 -->
              <div class="text-xs text-gray-50 mt-2">実働</div>
              <div class="flex gap-1 self-end justify-center">
                <input
                  type="number"
                  v-model="aw['workingHours' + w.id]"
                  onwheel="return false;"
                  :disabled="referenceMode"
                  class="text-sm text-right w-16 border-0 rounded text-gray-700 py-1.5"
                  @change="getBreakHours(aw, w.id)"
                />
                <div class="text-xs text-gray-50 self-center">時間</div>
              </div>

              <div class="text-xs text-gray-50 mt-2">休憩 {{ aw['breakHours' + w.id] || 0 }} 時間</div>

            </div>
            <!-- コピペ -->
            <div class="flex gap-2 pt-3 mt-auto h-fit" v-if="!referenceMode">
              <PrimaryButton class="bg-indigo-50 text-indigo-600 border-indigo-600 flex-1 px-1" size="xs" text="コピー" v-tooltip="'クリックするとこの曜日の勤務をコピーします'" @click="copy(aw, w.id)"></PrimaryButton>
              <PrimaryButton class="border-indigo-600 flex-1 px-1" size="xs" text="貼付" v-tooltip="'クリックするとコピーした勤務を反映します'" @click="paste(aw, w.id)" @disabled="!copied||!Object.keys(copied).length" :class="(!copied||!Object.keys(copied).length)?'bg-gray-200 text-white':'bg-indigo-100 text-indigo-600'"></PrimaryButton>
            </div>
          </div>
        </div>

        <SelectionOneValue
          caption="作業内容"
          v-model="aw.cdContentsWork"
          :list="workSelections"
          :required="isAdopt"
          :disabled="referenceMode"
          class="mt-2"
        ></SelectionOneValue>

        <SelectionOneValue
          caption="祝日区分"
          v-model="aw.cdKubunHoliday"
          :list="holidayType"
          :required="isAdopt"
          :disabled="referenceMode"
          class="mt-2"
        ></SelectionOneValue>

        <SelectionOneValue
          caption="全社祝日勤務"
          v-model="aw.hasExportingCompanysHoliday"
          :list="trashRemoval"
          :required="isAdopt"
          :disabled="referenceMode"
          class="mt-2"
        ></SelectionOneValue>

        <SelectionOneValue
          caption="ゴミ搬出"
          v-model="aw.hasCarryingoutGarbage"
          :list="trashRemoval"
          :required="isAdopt"
          :disabled="referenceMode"
          class="mt-2"
        ></SelectionOneValue>

        <div class="sm:col-span-full mt-5 text-sm font-bold text-blue-700 ml-1">
          <div v-if="requestPost.siteWage&&requestPost.siteWage.length" class="mt-1">※契約時給単価は {{ textForWage(requestPost.siteWage) }} のため、交通費含めこれより低い時給にしてください。</div>
          <div v-if="requestPost.siteWage&&requestPost.siteWage.length" class="mt-1">※登録・更新時にチェックします。</div>
          <div v-else-if="requestPost.interviewsSiteCode!='000000000'" class="mt-1">※契約時給単価 不明</div>
        </div>

        <div class="sm:col-span-full mt-1">
          <NumericTextInput2
            name="basicWage"
            caption="時給"
            v-model="aw.basicWage"
            @change="limitHourlyWageInput(aw)"
            :disabled="referenceMode"
            :required="isAdopt"
            :error="isAdopt&&!aw.basicWage"
          />
        </div>
        <!-- *******************交通費******************* -->
        <InputGroupLabel
          name="categoryTitle"
          caption="交通費（不要であれば0を入力）"
          class="mt-10"
        />

        <div class="flex gap-4 w-full mt-2">
          <SelectionOneValue
            caption="電車 区分"
            v-model="aw.kubunTrain"
            :list="provisionSelections"
            :required="isAdopt"
            :disabled="referenceMode"
            class="flex-1"
            @change="changeTrans(aw, 'kubunTrain', 'fareTrain')"
          ></SelectionOneValue>

          <NumericTextInput2
            name="fareTrain"
            caption="電車 交通費"
            maxLenght="5"
            v-model="aw.fareTrain"
            :required="isAdopt"
            :disabled="referenceMode"
            class="flex-1"
            :error="!aw.fareTrain"
          />
        </div>

        <div class="flex gap-4 w-full mt-2">
          <SelectionOneValue
            caption="バス 区分"
            v-model="aw.kubunBus"
            :list="provisionSelections"
            :required="isAdopt"
            :disabled="referenceMode"
            class="flex-1"
            @change="changeTrans(aw, 'kubunBus', 'fareBus')"
          ></SelectionOneValue>

          <NumericTextInput2
            name="fareBus"
            caption="バス 交通費"
            maxLenght="5"
            v-model="aw.fareBus"
            :required="isAdopt"
            :disabled="referenceMode"
            class="flex-1"
            :error="!aw.fareBus"
          />
        </div>

        <div class="flex gap-4 w-full mt-2">
          <SelectionOneValue
            caption="駐輪 区分"
            v-model="aw.kubunBicycleParking"
            :list="provisionSelections"
            :required="isAdopt"
            :disabled="referenceMode"
            class="flex-1"
            @change="changeTrans(aw, 'kubunBicycleParking', 'fareBicycleParking')"
          ></SelectionOneValue>

          <NumericTextInput2
            name="fareBicycleParking"
            caption="駐輪 交通費"
            maxLenght="5"
            v-model="aw.fareBicycleParking"
            :required="isAdopt"
            :disabled="referenceMode"
            class="flex-1"
            :error="!aw.fareBicycleParking"
          />
        </div>
      </div>

      <!-- *******************質問******************* -->
      <InputGroupLabel
        name="categoryTitle"
        caption="確認事項"
        class="mt-10"
      />

      <div class="sm:col-span-full mt-5">
        <SelectionOneValue
          caption="ご応募の物件ではなく、別の物件の相談は可能ですか？"
          v-model="requestPost.interviewsOtherPropertyConsultation"
          :list="yesnoSelections"
          :disabled="referenceMode"
        ></SelectionOneValue>

        <WmsTextInput
          name="interviewsDesiredDateAndTime"
          caption="その際の希望日数時間"
          v-model="requestPost.interviewsDesiredDateAndTime"
          :disabled="referenceMode"
          class="mt-2"
        />

        <SelectionOneValue
          caption="代行勤務は可能ですか？"
          v-model="requestPost.interviewsSubstituteWork"
          :list="yesnoSelections"
          :disabled="referenceMode"
          class="mt-2"
        ></SelectionOneValue>

        <WmsTextInput
          name="interviewsPossibleDateAndTime"
          caption="代行 可能日数・時間"
          v-model="requestPost.interviewsPossibleDateAndTime"
          :disabled="referenceMode"
          class="mt-2"
        />

        <WmsDateInput
          name="interviewsEarliestStartDate"
          caption="最短の勤務開始可能日"
          v-model="requestPost.interviewsEarliestStartDate"
          :clearable="true"
          :min="minDay"
          :disabled="referenceMode"
          class="mt-7"
        />

        <SelectionOneValue
          caption="タバコは吸われますか？"
          v-model="requestPost.interviewsSmoking"
          :list="yesnoSelections"
          :disabled="referenceMode"
          class="mt-7"
        ></SelectionOneValue>

        <SelectionOneValue
          caption="はいの場合は、通勤経路、就業時間中、職場内での禁煙出来ますか？"
          v-model="requestPost.interviewsSmokingBan"
          :list="yesnoSelections"
          :disabled="referenceMode"
          class="mt-2"
        ></SelectionOneValue>

        <SelectionOneValue
          caption="飲酒はされますか？"
          v-model="requestPost.interviewsAlcoholConsumption"
          :list="yesnoSelections"
          :disabled="referenceMode"
          class="mt-2"
        ></SelectionOneValue>

        <SelectionOneValue
          caption="身だしなみ、髪、爪等は清潔に保てますか。"
          v-model="requestPost.interviewsPersonalHygiene"
          :list="yesnoSelections"
          :disabled="referenceMode"
          class="mt-2"
        ></SelectionOneValue>

        <SelectionOneValue
          caption="試用期間終了後の異動可否"
          v-model="requestPost.interviewsTransferAfterProbation"
          :list="yesnoSelections"
          :disabled="referenceMode"
          class="mt-2"
        ></SelectionOneValue>

        <SelectionOneValue
          caption="ご家庭等の都合で月1回以上お休みしなければならないことがありますか？"
          v-model="requestPost.interviewsMonthlyLeaveForFamily"
          :list="yesnoSelections"
          :disabled="referenceMode"
          class="mt-2"
        ></SelectionOneValue>

        <WmsTextInput
          name="interviewsReasonForLeave"
          caption="はいの場合理由"
          v-model="requestPost.interviewsReasonForLeave"
          :disabled="referenceMode"
          class="mt-2"
        />

        <SelectionOneValue
          caption="止むを得ない理由により退職する際は、退職希望日の1ヶ月前に申し入れできますか？"
          v-model="requestPost.interviewsResignationNotice"
          :list="yesnoSelections"
          :disabled="referenceMode"
          class="mt-2"
        ></SelectionOneValue>

        <SelectionOneValue
          caption="お休みの場合は最低でも2週間前までに必ず会社に連絡ができますか？(急病や不幸は除きます。)"
          v-model="requestPost.interviewsContactBeforeLeave"
          :list="yesnoSelections"
          :disabled="referenceMode"
          class="mt-2"
        ></SelectionOneValue>

        <SelectionOneValue
          caption="清掃に関する仕事の経験はありますか？"
          v-model="requestPost.interviewsCleaningExperience"
          :list="yesnoSelections"
          :disabled="referenceMode"
          class="mt-2"
        ></SelectionOneValue>

        <SelectionOneValue
          caption="持病はありますか？"
          v-model="requestPost.interviewsChronicDisease"
          :list="yesnoSelections"
          :disabled="referenceMode"
          class="mt-2"
        ></SelectionOneValue>

        <SelectionOneValue
          caption="はいの方は当てはまるもの選択してください。"
          v-model="requestPost.interviewsApplicableDiseases"
          :list="yesnoSelections"
          :disabled="referenceMode"
          class="mt-2"
        ></SelectionOneValue>

        <WmsTextInput
          name="interviewsOtherConditions"
          caption="その他"
          v-model="requestPost.interviewsOtherConditions"
          :disabled="referenceMode"
          class="mt-2"
        />

        <SelectionOneValue
          caption="現在服用のお薬はありますか？"
          v-model="requestPost.interviewsCurrentMedication"
          :list="yesnoSelections"
          :disabled="referenceMode"
          class="mt-2"
        ></SelectionOneValue>

        <WmsTextInput
          name="interviewsMedicationDetails"
          caption="はいの方はお薬の種類を記載ください。"
          v-model="requestPost.interviewsMedicationDetails"
          :disabled="referenceMode"
          class="mt-2"
        />

        <SelectionOneValue
          caption="上記ご病気以外において体調で気になる部分はありますか？"
          v-model="requestPost.interviewsHealthConcerns"
          :list="yesnoSelections"
          :disabled="referenceMode"
          class="mt-2"
        ></SelectionOneValue>

        <WmsTextInput
          name="interviewsHealthConcernsDetails"
          caption="はいの場合"
          v-model="requestPost.interviewsHealthConcernsDetails"
          :disabled="referenceMode"
          class="mt-2"
        />

        <NumericTextInput2
          name="interviewsCognitiveTestScore"
          caption="認知テスト点数"
          maxLenght="3"
          v-model="requestPost.interviewsCognitiveTestScore"
          :disabled="referenceMode"
          class="mt-2"
        />

      </div>

      <InputGroupLabel
        name="categoryTitle"
        caption=""
        class="mt-10"
      />

      <div class="sm:col-span-full mt-3">

        <SelectionButton2
          name="interviewsMaterial"
          caption="必要な書類"
          v-model="requestPost.interviewsMaterial"
          :item="materialSelections"
          :multiSelect="true"
          :disabled="referenceMode"
          :required="isAdopt"
          :error="!requireValidateArr('interviewsMaterial', '必要な書類').result"
          :errorMessage="requireValidateArr('interviewsMaterial', '必要な書類').message"
          class="mt-3"
        />
      </div>

      <div class="sm:col-span-full mt-7">
        <WmsTextInput
          name="interviewsInterviewNotes"
          caption="面接管記入欄（評価・寸評）"
          v-model="requestPost.interviewsInterviewNotes"
          :multiline="true"
          :rows="5"
          :disabled="referenceMode"
        />
      </div>

      <div class="sm:col-span-full mt-3">
        <label class="block text-xs font-bold text-gray-700">
          認知症テスト結果
        </label>
        <div class="mt-1">
          <div class="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-1">
            <WmsAttachment
              name="interviewsCognitiveRes"
              style="max-width: none!important;"
              :value="requestPost.interviewsCognitiveRes"
              :disabled="referenceMode"
              @change="attachmentChange('interviewsCognitiveRes', $event)"
            />
          </div>
        </div>
      </div>

      <div class="sm:col-span-full mt-3">
        <label class="block text-xs font-bold text-gray-700 relative">
          添付資料（履歴書）<span v-if="isAdopt" class="absolute -top-0.5 ml-1 text-red-500"> * </span>
        </label>
        <div class="mt-1">
          <div class="grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-1">
            <WmsAttachment
              name="interviewsDocument"
              style="max-width: none!important;"
              :value="requestPost.interviewsDocument"
              :disabled="referenceMode"
              @change="attachmentChange('interviewsDocument', $event)"
              :errorMessage="requireValidateAttach('interviewsDocument', '履歴書').message"
            />
          </div>
        </div>
      </div>

      <div class="sm:col-span-full mt-3">
        <label class="block text-xs font-bold text-gray-700 relative">
          添付資料（紹介状・他）
        </label>
        <div class="mt-1 flex">
          <div class="w-full">
            <WmsAttachment
              name="commonFile"
              style="max-width: none!important;"
              :value="requestPost.commonFile"
              :disabled="referenceMode"
              @change="attachmentChange('commonFile', $event)"
            />
          </div>
          <!-- 添付資料（紹介状・他） 追加ボタン -->
          <div class="addButton-contents ml-5 my-auto" v-if="!referenceMode">
            <PrimaryButton class="bg-green-500" size="other" :buttonContents="'要'" v-tooltip="'追加'" @click="addCommonFile()">
              <Icon slot="before" iconName="PlusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
            </PrimaryButton>
          </div>
        </div>
      </div>

      <div  v-if="requestPost.interviewsCommonFileList&&requestPost.interviewsCommonFileList.includes(2)" class="sm:col-span-full mt-3">
        <label class="block text-xs font-bold text-gray-700 relative">
          添付資料（紹介状・他）
        </label>
        <div class="mt-1 flex">
          <div class="w-full">
            <WmsAttachment
              name="commonFile2"
              style="max-width: none!important;"
              :value="requestPost.commonFile2"
              :disabled="referenceMode"
              @change="attachmentChange('commonFile2', $event)"
            />
          </div>
          <!-- 添付資料（紹介状・他） 削除ボタン -->
          <div class="ml-5 my-auto" v-if="!referenceMode">
            <PrimaryButton class="bg-red-500" size="other" :buttonContents="'要'" v-tooltip="'削除'" @click="removeCommonFile(2)">
              <Icon slot="before" iconName="MinusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
            </PrimaryButton>
          </div>
        </div>
      </div>
      <div v-if="requestPost.interviewsCommonFileList&&requestPost.interviewsCommonFileList.includes(3)" class="sm:col-span-full mt-3">
        <label class="block text-xs font-bold text-gray-700 relative">
          添付資料（紹介状・他）
        </label>
        <div class="mt-1 flex">
          <div class="w-full">
            <WmsAttachment
              name="commonFile3"
              style="max-width: none!important;"
              :value="requestPost.commonFile3"
              :disabled="referenceMode"
              @change="attachmentChange('commonFile3', $event)"
            />
          </div>
          <!-- 添付資料（紹介状・他） 削除ボタン -->
          <div class="ml-5 my-auto" v-if="!referenceMode">
            <PrimaryButton class="bg-red-500" size="other" :buttonContents="'要'" v-tooltip="'削除'" @click="removeCommonFile(3)">
              <Icon slot="before" iconName="MinusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
            </PrimaryButton>
          </div>
        </div>
      </div>
      <div v-if="requestPost.interviewsCommonFileList&&requestPost.interviewsCommonFileList.includes(4)" class="sm:col-span-full mt-3">
        <label class="block text-xs font-bold text-gray-700 relative">
          添付資料（紹介状・他）
        </label>
        <div class="mt-1 flex">
          <div class="w-full">
            <WmsAttachment
              name="commonFile4"
              style="max-width: none!important;"
              :value="requestPost.commonFile4"
              :disabled="referenceMode"
              @change="attachmentChange('commonFile4', $event)"
            />
          </div>
          <!-- 添付資料（紹介状・他） 削除ボタン -->
          <div class="ml-5 my-auto" v-if="!referenceMode">
            <PrimaryButton class="bg-red-500" size="other" :buttonContents="'要'" v-tooltip="'削除'" @click="removeCommonFile(4)">
              <Icon slot="before" iconName="MinusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
            </PrimaryButton>
          </div>
        </div>
      </div>
      <div v-if="requestPost.interviewsCommonFileList&&requestPost.interviewsCommonFileList.includes(5)" class="sm:col-span-full mt-3">
        <label class="block text-xs font-bold text-gray-700 relative">
          添付資料（紹介状・他）
        </label>
        <div class="mt-1 flex">
          <div class="w-full">
            <WmsAttachment
              name="commonFile5"
              style="max-width: none!important;"
              :value="requestPost.commonFile5"
              :disabled="referenceMode"
              @change="attachmentChange('commonFile5', $event)"
            />
          </div>
          <!-- 添付資料（紹介状・他） 削除ボタン -->
          <div class="ml-5 my-auto" v-if="!referenceMode">
            <PrimaryButton class="bg-red-500" size="other" :buttonContents="'要'" v-tooltip="'削除'" @click="removeCommonFile(5)">
              <Icon slot="before" iconName="MinusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
            </PrimaryButton>
          </div>
        </div>
      </div>

      <div class="sm:col-span-full mt-3">
        <WmsTextInput
          name="employmentRemarks"
          caption="連絡事項"
          v-model="requestPost.employmentRemarks"
          :multiline="true"
          :rows="5"
          :disabled="referenceMode"
        />
      </div>
    </div>

    <div class="text-transparent text-xs">{{reload}}{{ reloadAttendance }}</div>

    <!-- 物件選択モーダル -->
    <SiteSelectorModal
      v-model="siteModal"
      :open="siteModal"
      @modalSiteSelected="siteSelected"
    />

    <!-- 募集媒体モーダル -->
    <EmploymentMediaModal
      v-model="openMediaModal"
      :open="openMediaModal"
      @close="closeMediaModal()"
    />
  </div>
</template>

<script>
  import Icon from '@components/Icon.vue'
  import InputIcon from '@components/InputIcon.vue'
  import PrimaryButton from '@components/PrimaryButton.vue'
  import WmsDateInput from '@wmscomponents/WmsDateInput.vue'
  import WmsTextInput from '@wmscomponents/WmsTextInput.vue'
  import moment from 'moment'
  import NumericTextInput2 from '@components/NumericTextInput2.vue'
  import SelectionOneValue from '@components/SelectionOneValue.vue'
  import SelectionButton2 from '@components/SelectionButton2.vue'
  import WmsTimeInput2 from '@wmscomponents/WmsTimeInput2.vue'
  import InputGroupLabel from '../components/InputGroupLabel.vue'
  import WmsAttachment from '@wmscomponents/WmsAttachment.vue'
  import WmsSuggestInput from '@wmscomponents/WmsSuggestInput.vue'
  import SiteSelectorModal from '../components/SiteSelectorModal.vue'
  import EmploymentMediaModal from '../components/EmploymentMediaModal.vue'
  import Multiselect from 'vue-multiselect'
  import LoadingIcon from '@assets/loading-circle.svg'
  import * as employmentMediaManager from '@managers/employmentMediaManager'
  import * as utils from '@libs/utils'
  import * as utilsAKBS from '@libs/utilsAKBS'
  import * as dialogs from '@libs/dialogs'
  import * as constants from '@libs/constants'
  import * as constantsAKBS from '@libs/constantsAKBS'
  import * as helper from '@libs/helper'
  import * as backend from '@libs/backend'

  const ACCEPTANCE_SELECTIONS = [
    {
      value: '採用',
      text: '採用'
    },
    {
      value: '不採用',
      text: '不採用'
    }
  ]

  const SEX_SELECTIONS = [
    {
      value: '男性',
      text: '男性'
    },
    {
      value: '女性',
      text: '女性'
    }
  ]

  const YESNO_SELECTIONS = [
    {
      id: 'はい',
      name: 'はい'
    },
    {
      id: 'いいえ',
      name: 'いいえ'
    }
  ]

  const DISEASE_SELECTIONS = [
    {
      value: '心臓疾患',
      text: '心臓疾患'
    },
    {
      value: '糖尿病',
      text: '糖尿病'
    },
    {
      value: 'ヘルニア',
      text: 'ヘルニア'
    },
    {
      value: '腰痛',
      text: '腰痛'
    },
    {
      value: '高血圧',
      text: '高血圧'
    }
  ]

  const WAY_SELECTIONS = [
    {
      value: '対面面接',
      text: '対面面接'
    },
    {
      value: 'WEB面接',
      text: 'WEB面接'
    }
  ]

  const FLG_SELECTIONS = [
    {
      value: 'あり',
      text: 'あり'
    },
    {
      value: 'なし',
      text: 'なし'
    }
  ]

  const FLG_SELECTIONS2 = [
    {
      value: '問題あり',
      text: '問題あり'
    },
    {
      value: '問題なし',
      text: '問題なし'
    }
  ]

  const TOBACCO_SELECTIONS = [
    {
      value: '喫煙者',
      text: '喫煙者'
    },
    {
      value: '非喫煙者',
      text: '非喫煙者'
    }
  ]

  const SOCIAL_SELECTIONS = [
    {
      value: '意欲的',
      text: '意欲的'
    },
    {
      value: '消極的',
      text: '消極的'
    }
  ]

  export default {
    components: {
      Icon,
      InputIcon,
      PrimaryButton,
      WmsDateInput,
      WmsTextInput,
      InputGroupLabel,
      NumericTextInput2,
      SelectionOneValue,
      SelectionButton2,
      WmsTimeInput2,
      WmsAttachment,
      WmsSuggestInput,
      SiteSelectorModal,
      EmploymentMediaModal,
      Multiselect,
      LoadingIcon
    },

    props: {
      requestPost: {
        type: Object,
        default: () => {}
      },
      isDisabled: {
        type: Boolean,
        default: false
      },
      isTaskRequestMode: {
        type: Boolean,
        default: false
      },
      referenceMode: {
        type: Boolean,
        default: false
      },
      // 面接権限ありor人事部
      isAuth: {
        type: Boolean,
        default: false
      },
      departmentLists: {
        type: Array
      },
    },

    data() {
      return {
        sexSelections: SEX_SELECTIONS,
        workSelections: constantsAKBS.WORK_SELECTIONS,
        holidayType: constantsAKBS.HOLIDAYTYPE_SELECTIONS,
        trashRemoval: constantsAKBS.YES_NO_CODE,
        areaSelections: constantsAKBS.AREA_SELECTIONS,
        provisionSelections: constantsAKBS.PROVISION_SELECTIONS,
        yesnoSelections: YESNO_SELECTIONS,
        diseaseSelections: DISEASE_SELECTIONS,
        acceptanceSelections: ACCEPTANCE_SELECTIONS,
        materialSelections: constants.MATERIAL_SELECTIONS,
        familyRelations: constants.FAMILIY_RELATIONS,
        hourItems: constants.HOURS,
        minuteItems: constants.MINUTES,
        waySelections: WAY_SELECTIONS,
        flgSelections: FLG_SELECTIONS,
        flgSelections2: FLG_SELECTIONS2,
        tobaccoSelections: TOBACCO_SELECTIONS,
        companySocialSelections: SOCIAL_SELECTIONS,
        domainList: constants.DOMAIN_SELECTIONS,
        today: moment().format('YYYY-MM-DD'),
        loading: false,
        reload: 0,
        reloadAttendance: 0,
        // 物件リスト
        buildingList: [],
        // 物件検索モーダル
        siteModal: false,
        // 募集媒体リスト
        mediaList: [],
        // 募集媒体リストモーダルopen
        openMediaModal: false,
        // チャットワークルームIDマスタモーダルopen
        openChatRoomId: false,
        // 選択できる最小日
        minDay: moment().format('YYYY-MM-DD'),
        mailTo: '',
        // 曜日リスト
        weekList: constantsAKBS.WEEK_LIST,
        // 勤務形態リスト
        attendanceList: utils.clone(constantsAKBS.ATTENDANCE),
        // コピーした値
        copied: {}
      }
    },

    computed: {
      /**
       * 誕生日を和暦に変換
       */
      japaneseDate() {
        return (val)=> {
          if (val) {
            return utils.japaneseDate(val)
          } else {
            return ''
          }
        }
      },

      /**
       * DC採用の場合
       */
      isAdopt() {
        if (this.requestPost.interviewsResult && this.requestPost.interviewsResult[0] && this.requestPost.interviewsResult[0] == '採用') {
          return true
        } else {
          return false
        }
      },

      /**
       * 行数をカウント
       */
      getRows() {
        return (val, num)=> {
          if (val) {
            const arr = val.split('\n')
            let rows = arr.length
            arr.forEach((a) => {
              if (a.length >= 77) {
                rows += Math.floor(a.length / 77)
              }
            })
            if (rows < num) {
              rows = num - 1
            }
            return rows + 1
          } else {
            return num
          }
        }
      },

      /**
       * 必須項目入力チェック（文字列）
       */
      requireValidateStr() {
        return (item, name)=> {
          // 入社日、作業開始日、勤務物件、エリアは、採用の場合のみ
          if (['interviewsHireDate', 'startDateWork', 'interviewsAppliedWorkLocationAddress', 'area', 'contractCode'].includes(item)) {
            if (this.isAdopt) {
              if (!this.requestPost[item] && this.requestPost[item] !== 0) {
                return {
                  result: false,
                  message: `採用の場合、${name}は必須項目です。${name}を入力してください。`
                }
              }
            }
          } else if (!this.requestPost[item] && this.requestPost[item] !== 0) {
            return {
              result: false,
              message: `${name}は必須項目です。${name}を入力してください。`
            }
          }
          return {
            result: true,
            message: ''
          }
        }
      },

      /**
       * 必須項目入力チェック（配列）
       */
      requireValidateArr() {
        return (item, name)=> {
          let required = true
          let saiyo = ''
          // 性別、必要な書類は採用の場合のみ
          if (['interviewsSex', 'interviewsMaterial'].includes(item)) {
            if (this.isAdopt) {
              required = true
              saiyo = '採用の場合、'
            } else {
              required = false
            }
          }

          if (required && (!this.requestPost[item] || !this.requestPost[item].length)) {
            return {
              result: false,
              message: `${saiyo + name}は必須項目です。${name}を選択してください。`
            }
          } else {
            return {
              result: true,
              message: ''
            }
          }
        }
      },

      /**
       * 必須項目入力チェック（添付ファイル）
       */
      requireValidateAttach() {
        return (item, name)=> {
          // 採用の場合に限る
          if (this.isAdopt && (!this.requestPost[item] || (!this.requestPost[item].content && !this.requestPost[item].url))) {
            return {
              result: false,
              message: `${name}は必須項目です。${name}を添付してください。`
            }
          } else {
            return {
              result: true,
              message: ''
            }
          }
        }
      },

      /**
       * 郵便番号入力形式確認
       */
      errPostCode() {
        return (post)=> {
          if (post) {
            const pattern = /^[0-9]{3}-[0-9]{4}$/
            //入力値が正しいか
            if (!pattern.test(post)) {
              return '【3桁-4桁】の形式で入力してください。'
            }
          }
          return ''
        }
      },

      /**
       * 携帯番号入力形式確認
       */
      errMobile() {
        return (num) => {
          if (num) {
            const pattern = /^[0-9]{3}-[0-9]{4}-[0-9]{4}$/
            //入力値が正しいか
            if (!pattern.test(num)) {
              return '【3桁-4桁-4桁】の形式で入力してください。'
            }
          }
          return ''
        }
      },

      /**
       * 時給単価をわかりやすく、文字列で表示
       */
      textForWage() {
        return (wage)=> {
          if (wage && wage.length) {
            if (this.requestPost.contractCode) {
              const res = wage.find((w) => {
                return w.cdContract == this.requestPost.contractCode
              })
              if (res) {
                return res.wage + '円'
              }
            }

            let text = ''
            let arr = {}
            for (let i = 0; i < wage.length; i++) {
              const w = wage[i]
              if (!arr[w.wage]) {
                arr[w.wage] = '契約コード' + w.cdContract
              } else {
                arr[w.wage] += '、' + w.cdContract
              }
            }

            if (Object.keys(arr).length == 1) {
              return Object.keys(arr)[0] + '円'
            }

            for (let i = 0; i < Object.keys(arr).length; i++) {
              const a = Object.keys(arr)[i]
              if (text) {
                text += '、'
              }
              text += '(' + arr[a] + ')➡' + a + '円'
            }
            return text
          }
          return ''
        }
      },

      /**
       * 一週間の実働合計
       */
      totalHours() {
        this.reloadAttendance
        if (this.requestPost.appliedWork && this.requestPost.appliedWork.length) {
          return utilsAKBS.getHoursForOneWeek(this.requestPost.appliedWork)
        }
        return 0
      },

      /**
       * 作業内容取得
       */
      getNameContentsWork() {
        return(val) => {
          if (val) {
            const tar = this.workSelections.find((w) => {
              return w.id == val
            })

            if (tar) {
              return tar.name
            }
          } else {
            return '不明'
          }
        }
      },

      /**
       * ありなし
       */
      getNameYesNo() {
        return(val) => {
          if (val != null) {
            const tar = this.trashRemoval.find((w) => {
              return w.id == val
            })

            if (tar) {
              return tar.name
            }
          } else {
            return '不明'
          }
        }
      },

      /**
       * 祝日勤務名取得
       */
      getNameHoliday() {
        return(val) => {
          if (val != null) {
            const tar = this.holidayType.find((w) => {
              return w.id == val
            })

            if (tar) {
              return tar.name
            }
          } else {
            return '不明'
          }
        }
      }
    },

    watch: {
      loading(val) {
        if (val) {
          this.$emit('loadingStart')
        } else {
          this.$emit('loadingEnd')
        }
      }
    },

    async created() {
      // 年齢が空であり、生年月日が設定されていた場合（初期値）⇒ 年齢検索
      if ((!this.requestPost.interviewsAge || this.requestPost.interviewsAge.length == 0)
            && this.requestPost.interviewsBirthDay && this.requestPost.interviewsBirthDay.length > 0) {
        this.ageCalculation()
      }
      // 物件リスト取得
      this.getBuildingList()
      // 募集媒体リスト取得
      this.getMediaList()

      // 新規の場合
      if (!this.requestPost._id) {
        this.requestPost.interviewsInputDay = moment().format('YYYY-MM-DD')
      }
    },

    methods: {

      /**
       * TEL入力用
       * @param event
       */
      onKeyPressTel(event) {
        // Allow numbers (charCode 48-57) and dash (charCode 45)
        if ((event.charCode >= 48 && event.charCode <= 57) ||  event.charCode === 45 ) {
          return true;
        } else {
          event.preventDefault(); // Prevent any other character from being entered
        }
      },

      /**
       * 生年月日から年齢を取得
       */
      ageCalculation(){
        if (!this.requestPost.interviewsBirthDay) {
          this.requestPost.interviewsAge = ''
        } else {
          var birthday = this.requestPost.interviewsBirthDay.split("-")
          var birth = moment().year(birthday[0]).month(birthday[1] - 1).date(birthday[2])
          this.requestPost.interviewsAge = String(moment().diff(birth, 'years'))
        }
      },

      /**
      * 郵便番号より住所検索
      */
      async addressSearch(post, value, i) {
        var geocoder = new window.google.maps.Geocoder()
        var pattern = /^[0-9]{3}-?[0-9]{4}$/
        let res = ''

        if(post) {
          var postalCode = post
          if (postalCode) {
            //入力値が正しいか
            if (pattern.test(postalCode)) {
              //住所を取得
              await geocoder.geocode ({
                address:postalCode,
                language:"ja",
                region:"jp"
              }, function (results, status) {
                if (status == window.google.maps.GeocoderStatus.OK) {
                  if (results.length > 0){
                    if (results[0].geometry) {
                      if (results[0].address_components[4].long_name == '日本') {
                        res = results[0].address_components[3].long_name +
                        results[0].address_components[2].long_name + results[0].address_components[1].long_name
                      } else {
                        res = results[0].address_components[4].long_name +
                        results[0].address_components[3].long_name + results[0].address_components[2].long_name +
                        results[0].address_components[1].long_name
                      }
                    }
                  }
                } else {
                  if (status == window.google.maps.GeocoderStatus.ZERO_RESULTS) {
                    res = ''
                    alert("郵便番号は見つかりませんでした。")
                  } else {
                    res = ''
                    alert("システムの管理者にお問い合わせください。ステータスコード：" + status)
                  }
                }
              })
            } else {
              alert("入力が3桁-4桁の形式であるか確認してください。")
            }
          }
        } else {
            alert("郵便番号を入力をしてください。")
        }

        if (i >= 0) {
          this.requestPost.emergency[i][value] = res
        } else {
          this.requestPost[value] = res
        }
        this.reload++
      },

      /**
      * 住所より郵便番号検索
      */
      postalCodeSearch(address, tar, i){
        var geocoder = new window.google.maps.Geocoder()
        const self = this
        if (!address) {
          alert("住所を入力してください")
          return
        }
        geocoder.geocode({
          address: address,
          language: "ja",
          region: "jp"
        }, function (results, status) {
          //アラート用フラグ
          var flag = false
          let res = ''
          if (status == window.google.maps.GeocoderStatus.OK) {
            if (results.length > 0) {
              if (results[0].geometry) {
                var result = results[0].address_components
                result.forEach(function(returnData) {
                  returnData.types.forEach(function(getType) {
                    if (getType == 'postal_code') {
                      res = returnData.long_name
                      flag = true
                    }
                  })
                })
              }
            }
            if (flag == false) {
              res = ''
              alert("郵便番号が見つかりませんでした。")
            }
          } else {
            if (status == window.google.maps.GeocoderStatus.ZERO_RESULTS) {
              res = ''
              alert("郵便番号は見つかりませんでした")
            } else {
              res = ''
              alert("システムの管理者にお問い合わせください。ステータスコード：" + status)
            }
          }

            // indexがある場合
            if (i >= 0) {
              self.requestPost.emergency[i][tar] = res
            } else {
              self.requestPost[tar] = res
            }
            self.reload++
        })
      },

      /**
      * 家族追加ボタン
      */
      addFamilyMember() {
        let add = {
          relationship: '',
          name: '',
          address:'',
          phoneNumber: ''
        }
        this.requestPost.familyMembers.push(add)
      },

      /**
      * 家族削除ボタン
      */
      removeFamilyMember(idx) {
        this.requestPost.familyMembers.splice(idx, 1)
        if (!this.requestPost.familyMembers || !this.requestPost.familyMembers.length) {
          this.addFamilyMember()
        }
      },

      /**
       * 緊急連絡追加ボタン
       */
      addEmergency() {
        this.requestPost.emergency.push({})
        this.reload++
      },

      /**
       * 緊急連絡削除ボタン
       */
      removeEmergency(i) {
        this.requestPost.emergency.splice(i, 1)
        if (!this.requestPost.emergency || !this.requestPost.emergency.length) {
          this.addEmergency()
        }
      },

      /**
      * 勤務曜日・時間 追加ボタン
      */
      addAppliedWork() {
        const copy = utils.clone(this.requestPost.appliedWork[0]) 
        this.requestPost.appliedWork.push(copy)
      },

      /**
      * 勤務曜日・時間 削除ボタン
      */
      removeAppliedWork(idx) {
        this.requestPost.appliedWork.splice(idx, 1)
        if (!this.requestPost.appliedWork || !this.requestPost.appliedWork.length) {
          this.addAppliedWork()
        }
      },

      /**
       * 曜日クリック
       * @param row 対象行
       * @param key クリックした曜日
       */
      clickWeek(row, key) {
        if (this.referenceMode) return

        if (row[key] && row[key].length) {
          row[key] = []
        } else {
          row[key] = [this.attendanceList[0]]
        }
        this.reloadAttendance++
      },

      /**
       * 実働時間セット
       */
      async setTime(row, key) {
        await utils.wait(200)
        let hours = utils.getHours(row['start' + key], row['end' + key])
        if (hours > 6) {
          hours--
        }
        row['workingHours' + key] = (hours)
        this.getBreakHours(row, key)
        this.reloadAttendance++
      },

      /**
       * 休憩時間算出
       */
      getBreakHours(row, key) {
        const hours = utils.getHours(row['start' + key], row['end' + key]) - (row['workingHours' + key] || 0)
        row['breakHours' + key] = hours
        this.reloadAttendance++
      },

      /**
       * 勤務コピー
       * @param row 対象データ
       * @param key 対象曜日キー
       */
      copy(row, key) {
        this.copied = {
          attendance: row['attendance' + key],
          start: row['start' + key],
          end: row['end' + key],
          workingHours: row['workingHours' + key],
          breakHours: row['breakHours' + key]
        }
      },

      /**
       * ペースト
       * @param row 対象データ
       * @param key 対象曜日キー
       */
      paste(row, key) {
        row['attendance' + key] = this.copied.attendance
        row['start' + key] = this.copied.start
        row['end' + key] = this.copied.end
        row['workingHours' + key] = this.copied.workingHours
        row['breakHours' + key] = this.copied.breakHours
        this.reloadAttendance++
      },

      /**
      * 交通費区分変更イベント
      * @param {*} row 対象行
      * @param type 区分
      * @param fee 交通費
      */
      changeTrans(row, type, fee) {
        if (row[type] == 0) {
          row[fee] = '0'
        } else if (row[type]) {
          if (row[fee] == '0') {
            row[fee] = ''
          }
        }
      },

      /**
      * タイトルをセット
      */
      setTitle() {
        // 採否結果＋名前＋物件名
        let t = {
          interviewsResult: this.requestPost.interviewsResult,
          name: this.requestPost.interviewsName,
          site: this.requestPost.interviewsAppliedWorkLocationAddress,
          interviewsRegularStaff: false,
          newGrad: false
        }
        this.$emit('get-title', t)
      },

      /**
      * 賃金の確認
      */
      async limitHourlyWageInput(row) {
        const err = utils.validateHourlyWage(row.basicWage)
        if (err) {
          await dialogs.showErrorDialog('賃金', err)
          row.basicWage = ''
          this.reload++
        }
      },

      /**
      * 添付ファイル
      */
      attachmentChange(targetAttachmentName, attachmentInfo) {
        if (!this.requestPost[targetAttachmentName]) {
          this.requestPost[targetAttachmentName] = helper.createEmptyAttachment()
        }
        if (attachmentInfo) {
          this.requestPost[targetAttachmentName].originalName = attachmentInfo.filename
          this.requestPost[targetAttachmentName].content = attachmentInfo.content
        } else {
          this.requestPost[targetAttachmentName] = helper.createEmptyAttachment()
        }
      },

      /**
      * 必須項目入力チェック
      */
      async validation() {
        // 入力形式確認
        if (this.errPostCode(this.requestPost.interviewsPostCode)) {
          await dialogs.showInfoDialog('郵便番号', '【3桁-4桁】の形式で入力してください。')
          return false
        }
        if (this.errMobile(this.requestPost.interviewsMobile)) {
          await dialogs.showInfoDialog('携帯番号', '【3桁-4桁-4桁】の形式で入力してください。')
          return false
        }

        // 緊急連絡先
        if (this.requestPost.emergency && this.requestPost.emergency.length) {
          for (let i = 0; i < this.requestPost.emergency.length; i++) {
            const e = this.requestPost.emergency[i]
            if (e.postCode) {
              if (this.errPostCode(e.postCode)) {
                await dialogs.showInfoDialog('緊急連絡先の郵便番号', '【3桁-4桁】の形式で入力してください。')
                return false
              }
            }
          }
        }

        // DCの必須項目（文字列、配列、オブジェクト）
        const dcVal = [
          { item: 'interviewsHireDate', name: '入社日' }
          ,{ item: 'interviewsKana', name: 'フリガナ' }
          ,{ item: 'interviewsName', name: '氏名' }
          ,{ item: 'interviewsPostCode', name: '郵便番号' }
          ,{ item: 'interviewsAddress1', name: '住所１' }
          ,{ item: 'interviewsMobile', name: '携帯電話' }
          ,{ item: 'interviewsSex', name: '性別' }
          ,{ item: 'interviewsBirthDay', name: '生年月日' }
          ,{ item: 'interviewsAppliedWorkLocationAddress', name: 'ご応募いただいた勤務物件' }
          ,{ item: 'appliedWork' }
          ,{ item: 'startDateWork', name: '作業開始日' }
          ,{ item: 'interviewsSiteCode', name: '物件コード' }
          ,{ item: 'contractCode', name: '契約コード' }
          ,{ item: 'area', name: 'エリア' }
          ,{ item: 'interviewsMaterial', name: '必要な書類' }
        ]

        // 年齢確認
        this.ageCalculation()
        const age = Number(this.requestPost.interviewsAge)
        if (age < 10 || age >= 100) {
          await dialogs.showErrorDialog('生年月日をご確認ください', `年齢が${age}歳 になっています。\r\n生年月日に間違いがないかご確認ください。`)
          return false
        }

        // 交通費時給に換算するため
        // 勤務回数カウント
        let workCount = 0

        for (let i = 0; i < dcVal.length; i++) {
          const s = dcVal[i]
          let res = {}

          // ご応募いただいた勤務曜日・時間の場合（連想配列）
          if (s.item == 'appliedWork') {
            const teiki = {}

            for (let j = 0; j < this.requestPost.appliedWork.length; j++) {
              const tar = this.requestPost.appliedWork[j]
              let flg = false
              let msg = ''
              if (j) {
                msg = (j + 1) + 'つ目の'
              }

              // 勤務内容
              for (let k = 0; k < this.weekList.length; k++) {
                const w = this.weekList[k]
                const key = w.id
                // 勤務形態
                const att = tar['attendance' + key]
                // 開始時間
                const start = tar['start' + key]
                // 終了時間
                const end = tar['end' + key]
                // 実働時間
                const hours = tar['workingHours' + key]

                // 勤務形態区分設定あり
                if (att && att.length) {
                  // 勤務日あり
                  workCount++
                  flg = true

                  // 矛盾していないか確認
                  if (!await utilsAKBS.checkAttendance(att, w.name)) return false

                  // 採用の場合
                  if (this.isAdopt) {
                    // 開始時間未入力
                    if (!await utilsAKBS.checkNoTimes(start, w.name + '曜日の勤務時間')) return false
                    // 終了時間未入力
                    if (!await utilsAKBS.checkNoTimes(end, w.name + '曜日の勤務時間')) return false
                  }

                  // 時間帯、実働の矛盾
                  if (start && end) {
                    if (!await utilsAKBS.checkTimes(start, w.name)) return false
                    if (!await utilsAKBS.checkTimes(end, w.name)) return false
                    if (!await utilsAKBS.checkTimes2(start, end, w.name)) return false
                    if (!await utilsAKBS.checkBreakTime(start, end, hours, w.name)) return false
                  }
                }
              }

              // 採用の場合
              if (this.isAdopt) {
                if (!flg) {
                  await dialogs.showErrorDialog(msg + '勤務', '1日も勤務日がありません。\n' + msg + '勤務を入力するか、削除してください。')
                  return false
                }

                const kubun = [
                  { item: 'cdContentsWork', name: '作業内容' }
                  ,{ item: 'cdKubunHoliday', name: '祝日区分' }
                  ,{ item: 'hasExportingCompanysHoliday', name: '全社祝日勤務' }
                  ,{ item: 'hasCarryingoutGarbage', name: 'ゴミ搬出' }
                  ,{ item: 'basicWage', name: '時給' }
                  ,{ item: 'kubunTrain', name: '電車 区分' }
                  ,{ item: 'fareTrain', name: '電車 交通費' }
                  ,{ item: 'kubunBus', name: 'バス 区分' }
                  ,{ item: 'fareBus', name: 'バス 交通費' }
                  ,{ item: 'kubunBicycleParking', name: '駐輪 区分' }
                  ,{ item: 'fareBicycleParking', name: '駐輪 交通費' }
                ]

                for (let j = 0; j < kubun.length; j++) {
                  const k = kubun[j]

                  if (!tar[k.item] && tar[k.item] !== 0) {
                    await dialogs.showErrorDialog(msg + k.name, '未入力です。入力してください。')
                    return false
                  }

                  if (!await this.comparisonContract(tar, k.item, k.name, null, msg)) return false

                  // 交通費の矛盾✓
                  if (!await utilsAKBS.checkTrans(k.item, k.name, tar, msg, teiki)) return false
                }
              }
            }

            if (this.isAdopt) {
              for (let i = 0; i < Object.keys(teiki).length; i++) {
                const t = Object.keys(teiki)[i]
                if (teiki[t].length > 1) {
                  if (await dialogs.showConfirmDialog('交通費 区分 1ヶ月の確認', teiki[t].join('\n') + '\nですが、よろしいですか？') != 'YES') return false
                }
              }
            }

            if (this.isAdopt && !workCount) {
              await dialogs.showErrorDialog('勤務を入力してください', '採用の場合、勤務は必須です。勤務する曜日の「勤務形態」を選択してください。')
              return false
            }
            if (workCount > 0) {
              if (this.requestPost.siteShort) {
                if (Number(this.requestPost.siteShort.total) >= 0) {
                  const log = await dialogs.showConfirmDialog('契約との時間差 確認', `現在こちらの物件は、不足時間はありませんが、登録してよろしいですか？\n退職予定の清掃員がいる場合は無視してください。`)
                  if (log != 'YES') {
                    return false
                  }
                } else if (this.totalHours > Number(this.requestPost.siteShort.total) * -1) {
                  const log = await dialogs.showConfirmDialog('契約との時間差 確認', `1週間の契約との過不足時間が${this.requestPost.siteShort.total}時間に対し、それを上回る ${this.totalHours} 時間を登録しようとしています。よろしいですか？\r\n退職予定の清掃員がいる場合は無視してください。`)
                  if (log != 'YES') {
                    return false
                  }
                }
              }
            }

            // 採用の場合、契約時給よりも少ないか確認
            if (this.isAdopt) {

              // 契約時給がある場合
              if (this.requestPost.siteWage && this.requestPost.contractCode) {
                let siteWage = 0
                const sw = this.requestPost.siteWage.find((w) => {
                  return w.cdContract == this.requestPost.contractCode
                })
                if (sw) {
                  siteWage = Number(sw.wage)
                }

                if (siteWage) {
                  let wage = 0
                  for (let i = 0; i < this.requestPost.appliedWork.length; i++) {
                    const row = this.requestPost.appliedWork[i]
                    // 交通費（時給換算）+時給
                    wage += utilsAKBS.getHourlyWage(row, null)
                  }
                  wage = Math.floor(wage / this.requestPost.appliedWork.length)
                  if (siteWage < wage) {
                    const log = await dialogs.showWarningConfirmDialog('時給・交通費の確認', `契約時給単価${siteWage}円に対し、交通費を含めた時給は${wage}円で、高くなっています。\nよろしいですか？`)
                    if (log != 'YES') {
                      return false
                    }
                  }
                }
              }
            }

          // 物件コード
          } else if (s.item == 'interviewsSiteCode') {
            if (this.isAdopt) {

              if (!this.requestPost.interviewsSiteCode) {
                await dialogs.showErrorDialog('物件を選択してください', '物件コードが取得できていません。リストの中から該当の物件を取得してください。')
                return false
              }

              if (this.requestPost.interviewsAppliedWorkLocationAddress != this.requestPost.targetSite) {
                await dialogs.showErrorDialog('物件名が書き変わっています', '物件を選択したら、物件名を手動で書き換えないようにお願いします。再度、ドロップダウンから物件を選択してください。')
                return false
              }
            }

          } else {
            if (Array.isArray(this.requestPost[s.item])) {
              res = this.requireValidateArr(s.item, s.name)
            } else {
              res = this.requireValidateStr(s.item, s.name)
            }

            if (!res.result) {
              await dialogs.showInfoDialog('入力確認', res.message, 'OK')
              return false
            }
          }
        }

        // 添付
        const valArr = [
          { item: 'interviewsDocument', name: '履歴書' }
        ]
        for (let i = 0; i < valArr.length; i++) {
          const a = valArr[i]
          let res = {}
          res = this.requireValidateAttach(a.item, a.name)
          if (!res.result) {
            await dialogs.showInfoDialog('入力確認', res.message, 'OK')
            return false
          }
        }

        return true
      },

      /**
       * 契約詳細情報と比較
       * @param item 項目
       * @param name 項目名
       */
      async comparisonContract(row, item, name, num) {
        // 採用決定で、代勤専門ではなく、契約コードがあり、対象項目の場合
        if (this.isAdopt && this.requestPost.interviewsSiteCode!='000000000' && this.requestPost.contractCode && ['cdKubunHoliday', 'hasCarryingoutGarbage', 'hasExportingCompanysHoliday'].includes(item)) {
          if (this.requestPost.contract && this.requestPost.contract.length) {
            const contract = this.requestPost.contract.find((c) => {
              return c.cdContract == this.requestPost.contractCode
            })

            if (!contract || !contract.cdContract) {
              this.requestPost.contractCode = null
              this.reload++
              await dialogs.showErrorDialog('契約コードを選択しなおしてください', '契約コードを選択してください。')
              return false
            }

            const val = row[item]
            let msg = ''

            switch (item) {
              case 'cdKubunHoliday':
                if (contract.holiday < val) {
                  msg = `契約コード（${contract.cdContract}）の契約は、${name}が${this.getNameHoliday(contract.holiday)} ですが、${this.getNameHoliday(val)}で登録しようとしています。よろしいですか？`
                }
                break;
              case 'hasCarryingoutGarbage':
                if (contract.garbage < val) {
                  msg = `契約コード（${contract.cdContract}の契約）は、${name}が${this.getNameYesNo(contract.garbage)} ですが、${this.getNameYesNo(val)}で登録しようとしています。よろしいですか？`
                }
                break;
              case 'hasExportingCompanysHoliday':
                if (contract.companyHoliday < val) {
                  msg = `契約コード（${contract.cdContract}）の契約は、${name}が${this.getNameYesNo(contract.companyHoliday)} ですが、${this.getNameYesNo(val)}で登録しようとしています。よろしいですか？`
                }
                break;
            }

            if (msg) {
              const log = await dialogs.showConfirmDialog(num + name, msg)
              if (log != 'YES') {
                return false
              }
            }
          }
        }
        return true
      },

      /**
      * 添付資料（紹介状・他）追加ボタン
      */
      async addCommonFile() {
        const files = this.requestPost.interviewsCommonFileList
        if (files && files.length <= 4) {
          for (let i = 1; i <= 5; i++) {
            if (!files.includes(i)) {
              files.push(i)
              this.reload++
              return
            }
          }
        } else if (files.length >= 5) {
          await dialogs.showInfoDialog('添付資料（紹介状・他）は5つまでです', 'これ以上、添付資料（紹介状・他）は増やせません。')
        }
      },

      /**
      * 添付資料（紹介状・他）削除ボタン
      * @param i 添付資料（紹介状・他）番号
      */
      removeCommonFile(i) {
        const files = this.requestPost.interviewsCommonFileList
        const res = files.filter((f) => {
          return i != f
        })
        this.requestPost.interviewsCommonFileList = res
      },

      /**
      * 物件リスト取得
      */
      async getBuildingList() {
        const list = await backend.searchData('akbsTable/getSiteList', null)

        const daikin = [{ nameSite: '代勤専門', cdSite: '000000000', clientCode: '' }]

        if (list && list.data.data && list.data.data.length) {
          this.buildingList = daikin.concat(list.data.data)
        } else {
          this.buildingList = []
        }
      },

      /**
      * 物件選択モーダルclose
      */
      siteSelected(target) {
        this.requestPost.interviewsSiteCode = target.cdSite
        this.requestPost.interviewsAppliedWorkLocationAddress = target.nameSite
        this.requestPost.interviewsSiteAddress = target.address
        // 選択した物件名を別で保存（チェックのため）
        this.requestPost.targetSite = target.nameSite

        // 得意先情報
        this.requestPost.clientCode = target.clientCode
        this.requestPost.clientName = ((target.nameCustomer || '') + ' ' + (target.nameCustomer2 || '')).trim()
        this.requestPost.clientFax = target.fax

        // 得意先住所
        this.requestPost.clientAddress1 = ''
        this.requestPost.clientAddress2 = ''
        this.getArea()

        // 詳細を取得
        this.getDetilSiteInfo(true)

        // タイトル編集
        this.setTitle()

        this.siteModal = false
      },

      /**
       * 物件の詳細情報を取得
       * @param isChangeContract 倹約コード変更フラグ
       */
      async getDetilSiteInfo(isChangeContract) {
        this.loading = true

        // 契約変更あり
        if (isChangeContract) {
          this.requestPost.contractCode = null
        }

        this.requestPost.siteWage = []
        this.requestPost.siteShort = {}
        this.requestPost.contract = []

        if (this.requestPost.interviewsSiteCode && this.requestPost.interviewsSiteCode != '000000000') {
          const res = await backend.searchData('akbs/getSiteWage', { siteCode: this.requestPost.interviewsSiteCode, onlyWage: false })

          // 時給単価
          if (res.data.data && res.data.data.wage) {
            for (let i = 0; i < res.data.data.wage.length; i++) {
              const r = res.data.data.wage[i]
              this.requestPost.siteWage.push({ cdContract: r.strRes2, wage: r.strRes3 })
            }
          }

          // 足りない時間（物件単位）
          if (res.data.data && res.data.data.short && res.data.data.short.length) {
            // 1物件1行のみ
            const s = res.data.data.short[0]
            this.requestPost.siteShort = { mon: Number(s.mon), tue: Number(s.tue), wed: Number(s.wed), thu: Number(s.thu), fri: Number(s.fri), sat: Number(s.sat), sun: Number(s.sun), total: Number(s.total), siteName: s.nameSite, date: moment().format('YYYY/MM/DD HH:mm') }
            Object.keys(this.requestPost.siteShort).forEach((s) => {
              // 過不足時間の色をセット
              this.setHoursColor(s, this.requestPost.siteShort[s], this.requestPost.siteShort)
            })
          }

          // 契約内容
          if (res.data.data && res.data.data.contract && res.data.data.contract.length) {
            this.requestPost.contract = res.data.data.contract
            this.requestPost.contract.forEach((c) => {
              c.date = moment().format('YYYY/MM/DD HH:mm')

              // 過不足時間の色をセット
              Object.keys(c).forEach((s) => {
                if (s.includes('2')) {
                  this.setHoursColor(s, Number(c[s]), c)
                }
              })
            })
            // 契約が1件しかない場合はその契約コードをセットする
            if (this.requestPost.contract.length == 1) {
              this.requestPost.contractCode = this.requestPost.contract[0].cdContract
              if (isChangeContract) {
                this.changeContract()
              }
            }
          }
        } else if (this.requestPost.interviewsSiteCode == '000000000') {
          this.requestPost.contractCode = '00'

          const row = this.requestPost.appliedWork[0]
          row.cdContentsWork = '50'
          row.cdKubunHoliday = 0
          row.hasCarryingoutGarbage = 0
          row.hasExportingCompanysHoliday = 0
        }
        this.loading = false
        this.reload++
      },

      /**
       * 過不足時間の色設定
       * @param key
       * @param value
       */
      setHoursColor(key, value, tar) {
        if (value < 0) {
          tar[key + 'Color'] = 'font-bold text-red-700'
        } else if (value > 0) {
          tar[key + 'Color'] = 'font-bold text-blue-700'
        }
      },

      /**
       * 契約コード変更
       */
      changeContract() {
        // 契約コードあり
        if (this.requestPost.contractCode) {
          if (this.requestPost.contract && this.requestPost.contract.length) {
            const res = this.requestPost.contract.find((c) => {
              return c.cdContract == this.requestPost.contractCode
            })

            this.requestPost.appliedWork.forEach(row => {

              // 作業内容
              row.cdContentsWork = res.cdContentsWork

              // 祝日区分
              row.cdKubunHoliday = res.holiday

              // ゴミ搬出
              row.hasCarryingoutGarbage = res.garbage

              // 全社祝日勤務
              row.hasExportingCompanysHoliday = res.companyHoliday
            })
          }
        }
      },

      /**
      * 物件変更イベント
      */
      siteChanged() {
        if (!this.requestPost.interviewsAppliedWorkLocationAddress) {
          this.requestPost.interviewsSiteCode = ''
          this.requestPost.interviewsAppliedWorkLocationAddress = ''
          this.requestPost.targetSite = ''
          this.requestPost.clientName = ''
          this.requestPost.clientCode = ''
          this.requestPost.clientFax = ''
          this.requestPost.interviewsSiteAddress = ''
          this.requestPost.area = ''
          this.requestPost.contractCode = null
          this.requestPost.siteWage = ''
          this.requestPost.siteShort = {}
          this.requestPost.contract = []
        }
      },

      /**
      * 住所からエリアを取得
      */
      getArea() {
        let ad = this.requestPost.interviewsSiteAddress

        // 代勤の場合は清掃員の住所
        if (this.requestPost.interviewsSiteCode == '000000000') {
          ad = this.requestPost.interviewsAddress1
        }

        if (ad) {
          for (let i = 0; i < this.areaSelections.length; i++) {
            const a = this.areaSelections[i]
            const name = a.replace('エリア', '')

            if (ad.includes(name)) {
              this.requestPost.area = a
              return
            }
          }
        }

        this.requestPost.area = null
      },

      /**
      * 物件選択モーダルopen
      */
      openSiteModal() {
        this.siteModal = true
      },

      /**
        * 募集媒体リスト取得
        */
      async getMediaList() {
        this.mediaList = await employmentMediaManager.getMediaList(this)
      },

      /**
        * 募集媒体モダール閉じる
        */
      closeMediaModal() {
        this.openMediaModal = false
        this.getMediaList()
      },
    }
  }
</script>

<style scoped>
  #diseaseDiv >>> button[type=button] {
    width: 19.8% !important;
  }

  .five-selection >>> button[type=button] {
    width: 19.8% !important;
  }

  #interviewsAppliedWorkDays >>> button[type=button] {
    width: 12% !important;
  }

  .send-date >>> input {
    text-align: center !important;
  }

  /* 入力欄を自動調整 */
  textarea {
    field-sizing: content !important;
  }

  .multiselect >>> .multiselect__tags {
    padding-right: 22px !important;
  }

  .multiselect >>> .multiselect__select {
    padding-right: 4px !important;
  }
</style>